import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import {
    ModalContent,
    ModalHeader,
    ModalRow,
    ModalRowLabel,
    ModalRowValue,
    ModalSection,
    ModalSectionTitle,
    ModalTitle,
    ScrollableContent,
} from "../Styles/InputStyles";
import { capitalizeFirstLetter, getTransferStatusConfig } from "../../helpers";
import ModalProfileHeader from "../Common/ModalProfileHeader";
import Config, { tranfer_payment_method } from "../../Config";

const ViewTransferDetails = ({ setViewDetails, selectedData }) => {
    const onClose = () => {
        setViewDetails(false);
    };

    const getPaymentMethodLabel = (methodValue) => {
        const method = tranfer_payment_method.find((m) => m.value === methodValue);
        return method ? method.label : "NA";
    };

    const { label, color } = getTransferStatusConfig(selectedData.status);


    return (
        <>
            <Container>
                <ModalHeader>
                    <ModalTitle>Transfer Details</ModalTitle>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>

                <ModalProfileHeader
                    title="Transfer Details"
                    name={capitalizeFirstLetter(selectedData?.name)}
                    subtitle={
                        <div className="flex items-center gap-1">
                            <span>#{selectedData?.transId}</span>
                        </div>
                    }
                    amountLabel={"Amount"}
                    amount={selectedData?.amount}
                    image={selectedData?.profilePicture}
                    onClose={onClose}
                />

                <ModalContent>
                    <ScrollableContent>
                        <Wrapper>
                            <BtnWrapper>
                                <ModalSectionTitle>Transfer Information</ModalSectionTitle>
                                <div className="flex items-start" >
                                    <span className={`rounded-lg py-1 px-2 text-sm font-semibold ${color}`}>
                                        {label}
                                    </span>
                                </div>
                            </BtnWrapper>
                            <ModalSection>
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Account Number</ModalRowLabel>
                                        <ModalRowValue className="flex items-center gap-1">
                                            {selectedData?.accountNum || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>IFSC Code</ModalRowLabel>
                                        <ModalRowValue className="uppercase">
                                            {selectedData?.ifsc || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Transfer Method</ModalRowLabel>
                                        <ModalRowValue>
                                            {getPaymentMethodLabel(selectedData?.transferMethod)}
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>UTR Number</ModalRowLabel>
                                        <ModalRowValue className="flex items-center gap-1">
                                            {selectedData?.transferUtr || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Transfer ID</ModalRowLabel>
                                        <ModalRowValue className="flex items-center gap-1">
                                            {selectedData?.transId || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>CF Transfer ID</ModalRowLabel>
                                        <ModalRowValue className="flex items-center gap-1">
                                            {selectedData?.cfTransferId || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Initiated At</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.createdAt
                                                ? moment(selectedData.createdAt).format(
                                                    "DD MMM YY, hh:mm A",
                                                )
                                                : "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Charges Deducted</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.vendorChargeDeducted
                                                ? ('₹' + selectedData?.vendorChargeDeducted)
                                                : "₹0"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                                {selectedData?.remark && (
                                    <ModalRow className="grid grid-cols-1">
                                        <FlexCol>
                                            <ModalRowLabel>Remarks</ModalRowLabel>
                                            <ModalRowValue>{selectedData?.remark}</ModalRowValue>
                                        </FlexCol>
                                    </ModalRow>
                                )}
                                {(selectedData?.status === Config.TRANSFER_STATUS.FAILED ||
                                    selectedData?.status === Config.TRANSFER_STATUS.REVERSED ||
                                    selectedData?.status === Config.TRANSFER_STATUS.REJECTED) && (
                                        <ModalRow className="grid grid-cols-1">
                                            <FlexCol>
                                                <ModalRowLabel>Description</ModalRowLabel>
                                                <ModalRowValue>
                                                    {selectedData?.statusDescription}
                                                </ModalRowValue>
                                            </FlexCol>
                                        </ModalRow>
                                    )}
                            </ModalSection>
                        </Wrapper>
                        {selectedData?.status === Config.TRANSFER_STATUS.SUCCESS &&
                            <Wrapper>
                                <BtnWrapper>
                                    <ModalSectionTitle>Charges Summary</ModalSectionTitle>
                                </BtnWrapper>
                                <ModalSection>
                                    <ModalRow>
                                        <FlexCol>
                                            <ModalRowLabel>Transfer Charges</ModalRowLabel>
                                            <ModalRowValue className="flex items-center gap-1">
                                                {selectedData?.charge ? '₹' + selectedData?.charge : "--"}
                                            </ModalRowValue>
                                        </FlexCol>
                                        <FlexCol>
                                            <ModalRowLabel>Taxes</ModalRowLabel>
                                            <ModalRowValue className="uppercase">
                                                {selectedData?.tax ? '₹' + selectedData?.tax : "--"}
                                            </ModalRowValue>
                                        </FlexCol>
                                    </ModalRow>
                                    <ModalRow>
                                        <FlexCol>
                                            <ModalRowLabel>Pre-Transfer Balance</ModalRowLabel>
                                            <ModalRowValue>
                                                {selectedData?.currentBalance ? '₹' + selectedData?.currentBalance : "--"}
                                            </ModalRowValue>
                                        </FlexCol>
                                        <FlexCol>
                                            <ModalRowLabel>Processed At</ModalRowLabel>
                                            <ModalRowValue>
                                                {selectedData?.updatedAt
                                                    ? moment(selectedData.updatedAt).format(
                                                        "DD MMM YY, hh:mm A",
                                                    )
                                                    : "--"}
                                            </ModalRowValue>
                                        </FlexCol>
                                    </ModalRow>

                                </ModalSection>
                            </Wrapper>
                        }

                    </ScrollableContent>
                </ModalContent>
            </Container>
        </>
    );
};

const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;

export default ViewTransferDetails;
